import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
import { IS_APP_CODEAC } from '../../../constants/env';
import { MissingPluginErrorMessage } from './MissingPluginErrorMessage';
import ESLintError from '../../../model/entities/ESLintError';
export class Errors extends Component {
    render() {
        const { t, rawReports } = this.props;
        const errors = rawReports.filter((report) => report.output);
        return errors.length === 0 ? null : (_jsx("div", { children: errors.map((report, index) => {
                let error;
                try {
                    error = JSON.stringify(JSON.parse(report.output), null, 2);
                }
                catch (exception) {
                    error = report.output;
                }
                const esLintError = new ESLintError({ errorMessage: error });
                const pluginName = esLintError.isMissingPlugin();
                return (_jsxs("div", { className: "alert alert-danger", children: [t('errorInTool'), " ", _jsx("strong", { children: report.tool }), ":", IS_APP_CODEAC && report.tool === 'eslint' && pluginName && _jsx(MissingPluginErrorMessage, { pluginName: pluginName }), report.tool === 'eslint' && !pluginName && (_jsx("div", { className: "ml-2 float-lg-right text-right", children: _jsxs("a", { href: "https://www.codeac.io/documentation/eslint-configuration.html", target: "_blank", rel: "noreferrer", children: [_jsx(Icon, { name: "info-circle-o", className: "mr-2" }), t('checkEslintDocumentation')] }) })), _jsx("pre", { className: "mb-0", children: error.split('\n').map((item, key) => (_jsxs("code", { children: [item, _jsx("br", {})] }, key))) })] }, index));
            }) }));
    }
}
export default withTranslation()(Errors);
